import { Box, Typography, Button, Stack } from "@mui/material";
import imageSection from "../../assets/area/AlTaiHills.jpg";

export default function PremiumCTASection() {
  return (
    <Box
      sx={{
        position: "relative",
        minHeight: { xs: "70vh", md: "60vh" },
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        textAlign: "center",
        backgroundImage: `url(${imageSection})`,
        backgroundSize: "cover",
        backgroundPosition: "center",
      }}
    >
      {/* OVERLAY */}
      <Box
        sx={{
          position: "absolute",
          inset: 0,
          background:
            "linear-gradient(180deg, rgba(0,0,0,0.10), rgba(0,0,0,0.18))",
        }}
      />

      {/* CONTENT */}
      <Box
        sx={{
          position: "relative",
          zIndex: 2,
          maxWidth: 900,
          px: { xs: 2, md: 4 },
        }}
      >
        <Typography
          sx={{
            fontSize: { xs: 30, sm: 38, md: 40 },
            fontWeight: 600,
            color: "#fff",
            lineHeight: 1.2,
            mb: 3,
            textShadow: "0 8px 24px rgba(0,0,0,0.35)",
          }}
        >
          Find Your Next Home with{" "}
          <Box component="span" sx={{ color: "var(--color-gold)" }}>
            Vision X Nexus
          </Box>
        </Typography>

        <Typography
          sx={{
            color: "rgba(255,255,255,0.9)",
            fontSize: { xs: 15, md: 17 },
            lineHeight: 1.8,
            maxWidth: 720,
            mx: "auto",
            mb: 5,
            textShadow: "0 8px 24px rgba(0,0,0,0.35)",
          }}
        >
          Looking to{" "}
          <strong style={{ color: "var(--color-gold)" }}>buy or invest</strong>{" "}
          in the UAE? Our experts guide you through every step — delivering a
          seamless, transparent, and rewarding real estate journey.
        </Typography>

        {/* BUTTONS */}
        <Stack
          direction={{ xs: "column", sm: "row" }}
          spacing={2}
          justifyContent="center"
        >
          {/* PRIMARY */}
          <Button
            component="a"
            href="tel:+971547914848"
            sx={{
              height: 54,
              px: 5,
              borderRadius: "40px",
              backgroundColor: "var(--color-gold)",
              color: "#1c1c1c",
              fontWeight: 600,
              letterSpacing: "0.12em",
              textTransform: "uppercase",
              boxShadow: "0 20px 50px rgba(0,0,0,0.4)",
              "&:hover": {
                backgroundColor: "var(--color-gold)",
                transform: "translateY(-2px)",
                boxShadow: "0 30px 70px rgba(0,0,0,0.55)",
              },
            }}
          >
            Call Us
          </Button>

          {/* SECONDARY */}
          <Button
            component="a"
            href="/contact"
            sx={{
              height: 54,
              px: 5,
              borderRadius: "40px",
              border: "1px solid rgba(255,255,255,0.8)",
              color: "#fff",
              fontWeight: 500,
              letterSpacing: "0.12em",
              textTransform: "uppercase",
              backdropFilter: "blur(6px)",
              "&:hover": {
                backgroundColor: "rgba(255,255,255,0.1)",
              },
            }}
          >
            Contact Us
          </Button>
        </Stack>
      </Box>
      {/* BOTTOM GOLD LINE */}
      <Box
        sx={{
          position: "absolute",
          bottom: 0,
          left: "5%",
          right: "5%",
          height: "1px",
          background:
            "linear-gradient(90deg, transparent, var(--color-gold), transparent)",
          opacity: 0.6,
        }}
      />
    </Box>
  );
}
